import { botonBitacora } from "./auditoria.js";
import { deleteData } from "../core/cloudSync.js";
import { renderDocFormModal } from "./documentos.js";
import { showConfirmDelete } from "../ui/modals.js";

import { saveData } from "../core/cloudSync.js";
import { navigateTo } from "../ui/app.js";
import {
  C, CARGOS_EMPLEADO, CARGO_LABELS, KEYS, MEDIOS_DESC_FIN, REGIMENES_FISCALES,
  TIPOS_CONTRATO, TIPO_CONTRATO_LABELS, NIVELES_RIESGO_ARL, NIVEL_RIESGO_ARL_LABELS,
  PERIODICIDAD_NOMINA, PERIODICIDAD_NOMINA_LABELS
} from "../core/config.js";
import { SIN_CONTACTO, contactosDe, etiquetaContacto } from "../core/contactos.js";
import { state } from "../core/state.js";
import { btnStyle, correoSinTildes, escapeHTML, fmtCOP, fmtDate, formatMiles, genId, inputStyle, parseNumber, parsePct, problemaCorreo, searchBox, searchFilter, siguienteCodigoProducto, today } from "../core/utils.js";
import { render } from "../ui/app.js";
import { zonaImagenHTML } from "../ui/imagenPegable.js";
import { persistirImagenProducto, srcImagenProducto } from "../core/imagenProducto.js";
import { IVA_EXCLUIDO, IVA_EXENTO, IVA_GRAVADO, etiquetaRegimen, ivaPct, leerValorOpcion, opcionesIVA, regimenDeProducto, valorOpcion } from "../core/iva.js";
import { armablesDeKit, costoBaseProducto, costoKitCatalogo, descripcionKitCatalogo, detalleArmablesKit, esProductoKit, productoPorNombre } from "../core/kitCatalogo.js";
import { getStockDisponible } from "../core/accounting.js";
import { getTablaComisiones, getVendedores } from "./comisiones.js";

export function renderMaestros() {
  const config = {
    clientes:    { label:"Clientes", icon:"👥", key:"clientes",    fields:["nombre","nit","contacto","telefono","asesor_comercial","dias_pago","email","ciudad","direccion"] },
    proveedores: { label:"Proveedores", icon:"🏭", key:"proveedores", fields:["nombre","nit","contacto","telefono","email","direccion","ciudad","dias_pago"] },
    productos:   { label:"Productos", icon:"📦", key:"productos",   fields:["codigo_interno","nombre","referencia","categoria","unidad","costo","margen","precio_venta"], cols: 8 }
  };
  // "vendedores" ya no es un tab propio de Maestros — el personal de ventas
  // ahora vive en el módulo de Empleados (state.data.empleados, cargo="vendedor").
  // Si un usuario tenía esa pestaña guardada de una sesión anterior, se cae a clientes.
  if (!state.maestrosTab || !config[state.maestrosTab]) state.maestrosTab = "clientes";
  const tab = state.maestrosTab;

  const current = config[tab];
  const allItems = state.data[current.key] || [];
  const query = state.searches.maestros || "";
  const items = searchFilter(allItems, query, current.fields);

  const header = `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:9px;padding-bottom:10px;border-bottom:3px solid ${C.gold};">
      <div style="display:flex;gap:10px;align-items:center;">
        <img src="${window.LOGO}" alt="Aura" style="height:42px;object-fit:contain;"/>
        <div>
          <h2 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">Maestros</h2>
          <p style="margin:3px 0 0;color:${C.muted};font-size:11.5px;">Clientes, proveedores y productos</p>
        </div>
      </div>
    </div>
  `;

  const tabs = Object.entries(config).map(([key, cfg]) => `
    <button data-action="maestros-tab" data-tab="${key}" style="
      padding:10px 18px;background:${tab === key ? "white" : "transparent"};
      border:none;
      border-bottom:3px solid ${tab === key ? C.accent : "transparent"};
      color:${tab === key ? C.amber : C.muted};
      font-weight:700;font-size:12px;cursor:pointer;margin-bottom:-1px;font-family:inherit;
    ">${cfg.icon} ${cfg.label} (${(state.data[cfg.key]||[]).length})</button>
  `).join("");

  let list;
  if (allItems.length === 0) {
    list = `
      <div style="padding:26px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;">
        <div style="font-size:40px;margin-bottom:10px;">${current.icon}</div>
        <div style="color:${C.muted};font-size:14px;">Sin ${current.label.toLowerCase()}</div>
      </div>
    `;
  } else if (items.length === 0) {
    list = `
      <div style="padding:22px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;">
        <div style="font-size:30px;margin-bottom:8px;">🔍</div>
        <div style="color:${C.text};font-size:14px;font-weight:600;margin-bottom:4px;">Sin resultados para "${escapeHTML(query)}"</div>
        <div style="color:${C.muted};font-size:11.5px;">Prueba con otros términos o limpia la búsqueda</div>
      </div>
    `;
  } else {
    const rows = items.map(item => `
      <tr style="border-top:1px solid ${C.border};">
        ${current.fields.slice(0, current.cols || 6).map(f => {
          let cell;
          if (["precio_venta","costo"].includes(f)) {
            cell = fmtCOP(item[f]);
          } else if (f === "margen") {
            cell = (item[f] != null && item[f] !== "") ? parseNumber(item[f]) + "%" : "—";
          } else if (f === "asesor_comercial") {
            cell = item[f]
              ? `<span style="background:${C.amber}18;color:${C.amber};padding:2px 8px;border-radius:6px;font-size:10.5px;font-weight:600;white-space:nowrap;">🧑‍💼 ${escapeHTML(item[f])}</span>`
              : `<span style="color:${C.muted};font-size:10.5px;">Sin asignar</span>`;
          } else if (f === "dias_pago") {
            const dp = item[f];
            cell = dp === "0" || dp === 0
              ? `<span style="background:#d1fae5;color:#065f46;padding:2px 7px;border-radius:6px;font-size:10.5px;font-weight:600;">Contado</span>`
              : dp ? `<span style="background:#f8fafc;color:#12264D;padding:2px 7px;border-radius:6px;font-size:10.5px;font-weight:600;">${dp}d</span>` : "—";
          } else if (f === "nombre" && current.key === "productos") {
            // El régimen de IVA se ve junto al nombre, y solo cuando NO es el
            // normal: una lista con 97 sellos de "IVA 19%" no informa de nada.
            const reg = regimenDeProducto(item);
            const sello = reg.tipo === IVA_GRAVADO && reg.pct === ivaPct() ? "" :
              `<span style="background:#fef3c7;color:#92400e;padding:2px 7px;border-radius:6px;font-size:9.5px;font-weight:700;margin-left:7px;white-space:nowrap;">${escapeHTML(etiquetaRegimen(reg))}</span>`;
            // Un kit se distingue a simple vista, con lo que trae y cuántos se
            // pueden armar hoy: es un artículo que no se busca en la bodega.
            const selloKit = !esProductoKit(item) ? "" :
              `<span style="background:#f3e8ff;color:#6b21a8;padding:2px 7px;border-radius:6px;font-size:9.5px;font-weight:700;margin-left:7px;white-space:nowrap;"
                 title="${escapeHTML(descripcionKitCatalogo(item))}">🧩 KIT · ${armablesDeKit(item, a => getStockDisponible(a)) || 0} armables</span>`;
            cell = escapeHTML(item[f] || "—") + sello + selloKit;
          } else {
            cell = escapeHTML(item[f] || "—");
          }
          return `<td style="padding:6px 10px;">${cell}</td>`;
        }).join("")}
        <td style="padding:6px 10px;text-align:right;white-space:nowrap;">
          <button data-action="edit-maestro" data-key="${current.key}" data-id="${item.id}" style="${btnStyle(null,"ghost",true)}">✏️</button>
          <button data-action="delete-maestro" data-key="${current.key}" data-id="${item.id}" style="${btnStyle(null,"ghost",true)}">🗑</button>
        </td>
      </tr>
    `).join("");

    list = `
      <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
        <table style="width:100%;border-collapse:collapse;font-size:12px;">
          <thead>
            <tr style="background:#f1f5f9;">
              ${current.fields.slice(0, current.cols || 6).map(f => `
                <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">${f === "margen" ? "MARGEN (%)" : f === "asesor_comercial" ? "ASESOR" : f === "dias_pago" ? "PAGO" : f === "precio_venta" ? "P. VENTA" : f === "referencia" ? "REFERENCIA" : f === "codigo_interno" ? "CÓDIGO" : f.toUpperCase()}</th>
              `).join("")}
              <th></th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    `;
  }

  return `
    ${header}
    <div style="display:flex;gap:6px;margin-bottom:10px;border-bottom:1px solid ${C.border};">${tabs}</div>
    <div style="display:flex;gap:9px;align-items:flex-start;margin-bottom:9px;">
      <div style="flex:1;">
        ${searchBox("search-maestros", query, "Buscar " + current.label.toLowerCase() + " por nombre, NIT, contacto, email...", C.amber)}
        ${query ? `<div style="font-size:10.5px;color:${C.muted};margin-top:-8px;margin-bottom:8px;">Mostrando ${items.length} de ${allItems.length}</div>` : ""}
      </div>
      <button data-action="new-maestro" data-key="${current.key}" style="${btnStyle(C.amber)}">+ Nuevo</button>
    </div>
    ${list}
  `;
}

export function showMaestroForm(key, item) {
  
  // Validar que key es válido
  if (!KEYS[key]) {
    console.error("❌ ERROR: key inválido para maestro: " + key);
    alert("❌ Error: Tipo de maestro inválido");
    return;
  }
  
  // Inicializar estado
  state.editingMaestro = item ? JSON.parse(JSON.stringify(item)) : {};
  state.editingMaestroKey = key;

  // Migración: terceros antiguos guardaban regimen_iva:"responsable"/"no_responsable".
  // Si el tercero aún no tiene el campo nuevo (responsable_iva, boolean), lo derivamos
  // del valor antiguo para no perder la configuración ya cargada.
  if ((key === "clientes" || key === "proveedores") && state.editingMaestro.responsable_iva === undefined) {
    state.editingMaestro.responsable_iva = state.editingMaestro.regimen_iva
      ? state.editingMaestro.regimen_iva === "responsable"
      : true; // por defecto, responsable de IVA (régimen ordinario más común)
  }
  if ((key === "clientes" || key === "proveedores") && !state.editingMaestro.regimen_fiscal) {
    state.editingMaestro.regimen_fiscal = "ordinario";
  }
  
  
  // Renderizar modal
  renderMaestroFormModal();
}

export function fichaProductoHTML(prod) {
  if (!prod || !prod.nombre) return "";
  const invItem = (state.data.inventario||[]).find(i => i.articulo === prod.nombre);
  const stock   = invItem ? (parseNumber(invItem.stock)||0) : 0;
  const cpp     = invItem ? (parseNumber(invItem.costo_promedio)||0) : (parseNumber(prod.costo)||0);
  const valTot  = Math.round(stock * cpp);
  const costoC  = parseNumber(prod.costo)||0;
  const difPct  = costoC > 0 ? ((cpp - costoC) / costoC * 100).toFixed(1) : null;
  const movs    = invItem?._movimientos || [];

  // ── Tab activo en la ficha (state.fichaTab: "kardex" | "documentos")
  const fichaTab = state.fichaTab || "kardex";
  const docTipo  = state.fichaDocTipo || "todos";

  // ── KPIs ─────────────────────────────────────────────────────────────────
  const kpiCard = (lbl, val, sub, col, bg) => `
    <div style="background:${bg};border:1px solid ${col}30;border-radius:6px;padding:12px 14px;">
      <div style="font-size:9px;font-weight:700;color:${col};text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px;">${lbl}</div>
      <div style="font-size:17px;font-weight:800;color:${col};">${val}</div>
      ${sub?`<div style="font-size:10px;color:#64748b;margin-top:2px;">${sub}</div>`:""}
    </div>`;

  const difLabel = difPct !== null
    ? `<span style="color:${parseFloat(difPct)>0?"#dc2626":parseFloat(difPct)<0?"#16a34a":"#64748b"};font-weight:700;">${difPct>0?"+":""}${difPct}% vs catálogo</span>`
    : "";

  const kpis = `
    <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:9px;">
      ${kpiCard("CPP Actual",      fmtCOP(cpp),    difLabel,    "#0E7490","#f0fdfa")}
      ${kpiCard("Stock",           stock+" uds",   "disponible","#4C5FA8","#eef1f8")}
      ${kpiCard("Valor cta. 1435", fmtCOP(valTot),"stock×CPP", "#12264D","#eff6ff")}
      ${kpiCard("Costo catálogo",  fmtCOP(costoC), "campo fijo","#64748b","#f8fafc")}
    </div>`;

  // ── Tabs de la ficha ──────────────────────────────────────────────────────
  const tabBtn = (id, lbl, act) => `
    <button onclick="state.fichaTab='${id}';renderMaestroFormModal();"
      style="padding:6px 14px;border:none;border-bottom:2px solid ${act?"#0E7490":"transparent"};
      background:transparent;font-size:11.5px;font-weight:700;cursor:pointer;
      color:${act?"#0E7490":"#94a3b8"};">${lbl}</button>`;

  const fichaTabsHTML = `
    <div style="display:flex;gap:4px;border-bottom:1px solid #e2e8f0;margin-bottom:9px;">
      ${tabBtn("kardex",    "📊 Kardex CPP",          fichaTab==="kardex")}
      ${tabBtn("documentos","📋 Documentos relacionados", fichaTab==="documentos")}
    </div>`;

  // ── TAB 1: Kardex CPP ─────────────────────────────────────────────────────
  let fichaBodyHTML = "";
  if (fichaTab === "kardex") {
    if (movs.length === 0) {
      fichaBodyHTML = `<div style="text-align:center;padding:14px;color:#94a3b8;font-size:11.5px;">
        <div style="font-size:28px;margin-bottom:8px;">📭</div>
        Sin movimientos de inventario registrados para este producto.<br>
        Los movimientos aparecen al recepcionar OCPs.
      </div>`;
    } else {
      // Minigráfico SVG de evolución del CPP
      const cpps  = movs.map(m => parseNumber(m.costo_promedio_resultante)||0);
      const maxCPP = Math.max(...cpps, 1);
      const minCPP = Math.min(...cpps);
      const W=340, H=60, pad=8;
      const pts = cpps.map((v,i) => {
        const x = pad + (i/(Math.max(cpps.length-1,1)))*(W-pad*2);
        const y = H-pad - ((v-minCPP)/(maxCPP-minCPP||1))*(H-pad*2);
        return `${x},${y}`;
      }).join(" ");
      const grafico = cpps.length > 1 ? `
        <div style="margin-bottom:12px;background:#f8fafc;border:1px solid #a7f3d0;border-radius:6px;padding:7px 10px;">
          <div style="font-size:9px;font-weight:700;color:#0E7490;margin-bottom:6px;text-transform:uppercase;letter-spacing:.4px;">Evolución del Costo Promedio Ponderado</div>
          <svg viewBox="0 0 ${W} ${H}" style="width:100%;height:${H}px;">
            <polyline points="${pts}" fill="none" stroke="#0E7490" stroke-width="2" stroke-linejoin="round"/>
            ${cpps.map((v,i)=>{
              const x=pad+(i/(Math.max(cpps.length-1,1)))*(W-pad*2);
              const y=H-pad-((v-minCPP)/(maxCPP-minCPP||1))*(H-pad*2);
              return `<circle cx="${x}" cy="${y}" r="3" fill="#0E7490"/>
                <title>${fmtCOP(v)}</title>`;
            }).join("")}
          </svg>
          <div style="display:flex;justify-content:space-between;font-size:9px;color:#64748b;margin-top:2px;">
            <span>${fmtCOP(cpps[0])}</span><span>→</span><span>${fmtCOP(cpps[cpps.length-1])}</span>
          </div>
        </div>` : "";

      // Tabla kardex
      const filasMov = [...movs].reverse().map(m => {
        const esEntrada = m.tipo==="entrada";
        const col = esEntrada?"#059669":"#dc2626";
        const bg  = esEntrada?"#f0fdf4":"#fef2f2";
        // La nota dice por qué salió este producto cuando el documento habla de
        // otro: es una PARTE del artículo que se entregó armado.
        const origLabel = m.origen
          ? `${m.origen.tipo} ${m.origen.numero||""}${m.origen.nota ? ` · ${m.origen.nota}` : ""}`
          : "—";
        return `
          <tr style="border-bottom:1px solid #f1f5f9;background:${bg}15;">
            <td style="padding:6px 8px;font-size:10px;color:#64748b;">${fmtDate(m.fecha)}</td>
            <td style="padding:6px 8px;">
              <span style="background:${bg};color:${col};padding:2px 7px;border-radius:6px;font-size:9px;font-weight:700;">${esEntrada?"↑ ENTRADA":"↓ SALIDA"}</span>
            </td>
            <td style="padding:6px 8px;text-align:right;font-size:10.5px;font-weight:700;color:${col};">${esEntrada?"+":""}${Math.abs(m.cantidad)}</td>
            <td style="padding:6px 8px;text-align:right;font-size:10.5px;">${fmtCOP(Math.abs(m.costo_unitario||0))}</td>
            <td style="padding:6px 8px;text-align:right;font-weight:800;font-size:10.5px;color:#0E7490;">${fmtCOP(m.costo_promedio_resultante||0)}</td>
            <td style="padding:6px 8px;text-align:right;font-size:10.5px;color:#374151;">${m.stock_resultante??""}</td>
            <td style="padding:6px 8px;font-size:10px;color:#4C5FA8;">${escapeHTML(origLabel)}</td>
          </tr>`;
      }).join("");

      fichaBodyHTML = grafico + `
        <div style="overflow:auto;max-height:200px;border:1px solid #e2e8f0;border-radius:6px;">
          <table style="width:100%;border-collapse:collapse;font-size:10.5px;">
            <thead>
              <tr style="background:#f8fafc;position:sticky;top:0;">
                <th style="padding:6px 8px;text-align:left;font-size:9px;font-weight:700;color:#475569;">Fecha</th>
                <th style="padding:6px 8px;text-align:left;font-size:9px;font-weight:700;color:#475569;">Tipo</th>
                <th style="padding:6px 8px;text-align:right;font-size:9px;font-weight:700;color:#475569;">Cantidad</th>
                <th style="padding:6px 8px;text-align:right;font-size:9px;font-weight:700;color:#475569;">Costo Unit.</th>
                <th style="padding:6px 8px;text-align:right;font-size:9px;font-weight:700;color:#0E7490;">CPP Result.</th>
                <th style="padding:6px 8px;text-align:right;font-size:9px;font-weight:700;color:#475569;">Stock</th>
                <th style="padding:6px 8px;text-align:left;font-size:9px;font-weight:700;color:#4C5FA8;">Origen</th>
              </tr>
            </thead>
            <tbody>${filasMov}</tbody>
          </table>
        </div>`;
    }
  }

  // ── TAB 2: Documentos relacionados ───────────────────────────────────────
  if (fichaTab === "documentos") {
    const tiposDoc = [
      { id:"todos",    lbl:"Todos" },
      { id:"OCP",      lbl:"Ingresos / OCP" },
      { id:"RC",       lbl:"Remisiones" },
      { id:"FACT",     lbl:"Facturas" },
      { id:"NC",       lbl:"Notas Crédito" },
      { id:"AJU",      lbl:"Ajustes" }
    ];

    // Recopilar todos los movimientos del producto con su tipo de documento
    const docsRel = movs
      .filter(m => m.origen && m.origen.tipo)
      .filter(m => docTipo==="todos" || m.origen.tipo===docTipo)
      .map(m => {
        const col  = m.tipo==="entrada"?"#059669":"#dc2626";
        const bg   = m.tipo==="entrada"?"#f0fdf4":"#fef2f2";
        const tipoLabel = { OCP:"🛒 OCP", RC:"📦 Remisión", FACT:"💰 Factura", NC:"🧾 Nota Crédito", AJU:"⚖️ Ajuste" }[m.origen.tipo] || m.origen.tipo;
        return `
          <div style="display:flex;align-items:center;gap:10px;padding:8px 10px;border-bottom:1px solid #f1f5f9;background:${bg}15;">
            <div style="flex-shrink:0;font-size:10.5px;color:#64748b;min-width:72px;">${fmtDate(m.fecha)}</div>
            <span style="background:${bg};color:${col};padding:2px 8px;border-radius:6px;font-size:9px;font-weight:700;flex-shrink:0;">${m.tipo==="entrada"?"↑ ENTRADA":"↓ SALIDA"}</span>
            <div style="flex:1;">
              <div style="font-weight:700;font-size:10.5px;color:#4C5FA8;">${tipoLabel} <span style="color:#374151;">${escapeHTML(m.origen.numero||"")}</span>${m.origen.nota ? `<span style="color:#7c3aed;font-weight:700;"> · 🧩 ${escapeHTML(m.origen.nota)}</span>` : ""}</div>
            </div>
            <div style="text-align:right;flex-shrink:0;">
              <div style="font-weight:700;font-size:10.5px;color:${col};">${m.tipo==="entrada"?"+":""}${Math.abs(m.cantidad)} uds</div>
              <div style="font-size:9px;color:#64748b;">CPP ${fmtCOP(m.costo_promedio_resultante||0)}</div>
            </div>
          </div>`;
      });

    const selectorTipos = tiposDoc.map(t => `
      <button onclick="state.fichaDocTipo='${t.id}';renderMaestroFormModal();"
        style="padding:4px 10px;border-radius:6px;border:1px solid ${docTipo===t.id?"#4C5FA8":"#e2e8f0"};
        background:${docTipo===t.id?"#eef1f8":"white"};color:${docTipo===t.id?"#4C5FA8":"#64748b"};
        font-size:10.5px;font-weight:700;cursor:pointer;white-space:nowrap;">${t.lbl}</button>
    `).join("");

    fichaBodyHTML = `
      <div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:12px;">${selectorTipos}</div>
      <div style="border:1px solid #e2e8f0;border-radius:6px;overflow:hidden;max-height:220px;overflow-y:auto;">
        ${docsRel.length > 0 ? docsRel.join("") : `
          <div style="text-align:center;padding:14px;color:#94a3b8;font-size:11.5px;">
            <div style="font-size:17px;margin-bottom:6px;">📭</div>
            Sin documentos${docTipo!=="todos"?" de ese tipo":""} para este producto.
          </div>`}
      </div>`;
  }

  return `
    <div style="margin-top:18px;padding-top:16px;border-top:2px solid #0E7490;">
      <div style="font-size:12px;font-weight:800;color:#0E7490;margin-bottom:12px;">📊 Ficha de Costo — ${escapeHTML(prod.nombre)}</div>
      ${kpis}
      ${fichaTabsHTML}
      ${fichaBodyHTML}
    </div>`;
}

// Aviso del correo de facturación electrónica. Vive aparte porque se pinta en
// dos momentos: al abrir la ficha y mientras se escribe en el campo (sin volver
// a renderizar el modal, que perdería el cursor).
export function avisoCorreoFEHTML(valor) {
  const mal = problemaCorreo(valor);
  if (!mal) return "";
  const sug = correoSinTildes(valor);
  return `<div style="margin-top:6px;background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;padding:7px 9px;font-size:10.5px;color:#991b1b;line-height:1.45;">
    ⛔ Este correo ${escapeHTML(mal)}. La factura saldrá marcada como enviada, pero ese buzón casi seguro rebota y el cliente no la recibirá${sug && sug !== String(valor || "").trim() ? `. ¿Será <strong>${escapeHTML(sug)}</strong>?` : "."}
  </div>`;
}

export function renderMaestroFormModal() {
  const key = state.editingMaestroKey;
  const f = state.editingMaestro;
  
  
  // Definir campos por tipo
  const fields = {
    clientes:    ["nombre","nit","contacto","contacto_cargo","telefono","asesor_comercial","email","direccion","ciudad","dias_pago","forma_pago"],
    proveedores: ["nombre","nit","contacto","telefono","email","direccion","ciudad","dias_pago"],
    productos:   ["nombre","referencia","categoria","unidad","iva_regimen","costo","margen","precio_venta"],
    empleados:   ["nombre","cedula","cargo","es_vendedor","telefono","email","rango","fecha_cumpleanos","genero","eps","arl","fondo_pensiones","banco","cuenta_bancaria","salario_base","fecha_ingreso","tipo_contrato","nivel_riesgo_arl","periodicidad_pago"]
  }[key];

  if (!fields) {
    console.error("❌ ERROR: No se encontraron campos para: " + key);
    return;
  }

  const labels = {
    nombre:"Nombre", nit:"NIT", contacto:"Contacto",
    contacto_cargo:"Cargo del contacto",
    telefono:"Teléfono", email:"Email", direccion:"Dirección",
    ciudad:"Ciudad", categoria:"Categoría", unidad:"Unidad",
    precio_venta:"Precio de venta", costo:"Costo", margen:"Margen de utilidad (%)",
    dias_pago:"Días de Pago (Condiciones)",
    forma_pago:"Forma de pago",
    referencia:"Referencia / Código",
    asesor_comercial:"Asesor comercial",
    cedula:"Cédula", fecha_cumpleanos:"Fecha de cumpleaños", genero:"Género",
    cargo:"Cargo",
    rango:"Rango / Categoría de vendedor",
    es_vendedor:"¿También es vendedor?",
    iva_regimen:"IVA del producto",
    eps:"EPS", arl:"ARL", fondo_pensiones:"Fondo de Pensiones",
    cuenta_bancaria:"N° Cuenta Bancaria", banco:"Banco",
    salario_base:"Salario base", fecha_ingreso:"Fecha de ingreso",
    tipo_contrato:"Tipo de contrato", nivel_riesgo_arl:"Nivel de riesgo ARL",
    periodicidad_pago:"Periodicidad de pago"
  };

  // Generar inputs
  const inputs = fields.map(field => {
    const isNumber = ["precio_venta","costo","margen","salario_base"].includes(field);
    const isMargen = field === "margen";
    const isPrecioVentaCalc = field === "precio_venta" && key === "productos";
    const isDiasPago = field === "dias_pago";
    const isFormaPago = field === "forma_pago";
    const isFecha = field === "fecha_cumpleanos" || field === "fecha_ingreso";
    const isGenero = field === "genero";
    const isRango = field === "rango" && key === "empleados";
    const isEsVendedor = field === "es_vendedor" && key === "empleados";
    const isIvaRegimen = field === "iva_regimen" && key === "productos";
    const isCargo = field === "cargo" && key === "empleados";
    const isAsesor = field === "asesor_comercial";
    const isBanco = field === "banco";
    const isTipoContrato = field === "tipo_contrato";
    const isNivelRiesgoArl = field === "nivel_riesgo_arl";
    const isPeriodicidadPago = field === "periodicidad_pago";
    const colSpan = (field === "direccion" || field === "asesor_comercial") ? "grid-column:1/3;" : "";
    const value = f[field] != null ? String(f[field]) : "";


    // ─── Régimen de IVA del producto ──────────────────────────────────────
    // Casi todo lo que vende Mathiz es gravado a la tarifa general, así que esa
    // es la opción por defecto y no hay que tocar nada. Las otras tres existen
    // porque la ley las distingue, y la ayuda dice QUÉ implica cada una: quien
    // clasifica un producto no tiene por qué saberse el Estatuto de memoria.
    if (isIvaRegimen) {
      const opciones = opcionesIVA();
      const actual = regimenDeProducto(f);
      const seleccionado = `${actual.tipo}:${actual.pct}`;
      const elegida = opciones.find(o => valorOpcion(o) === seleccionado) || opciones[0];
      const color = actual.tipo === IVA_GRAVADO ? C.muted : "#92400e";
      return `
        <div style="grid-column:1/3;">
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">🧾 ${labels[field]}</label>
          <select data-form="iva_regimen" style="${inputStyle}cursor:pointer;">
            ${opciones.map(o => `<option value="${valorOpcion(o)}" ${valorOpcion(o) === seleccionado ? "selected" : ""}>${escapeHTML(o.lbl)}</option>`).join("")}
          </select>
          <div style="margin-top:5px;font-size:10px;color:${color};line-height:1.45;">${escapeHTML(elegida.ayuda)}</div>
          ${actual.tipo !== IVA_GRAVADO ? `
            <div style="margin-top:6px;background:#fffbeb;border:1px solid #fcd34d;border-radius:6px;padding:7px 9px;font-size:10px;color:#78350f;line-height:1.5;">
              Se factura en <strong>cero</strong>, y en la factura aparece como base
              ${actual.tipo === IVA_EXENTO ? "exenta" : "excluida"}, separada de la gravada.
              ${actual.tipo === IVA_EXCLUIDO
                ? "El IVA que el proveedor cobre por este bien <strong>no es descontable</strong>: va como mayor costo."
                : "El derecho a descontables y devolución es solo del <strong>productor</strong> del bien (art. 440 E.T.); como comercializador se vende sin IVA y sin descontables."}
              Vender esto junto con productos gravados obliga a prorratear el IVA de los costos comunes (art. 490 E.T.).
            </div>` : ""}
        </div>
      `;
    }

    if (isDiasPago) {
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <select data-form="${field}" style="${inputStyle}">
            <option value="">— Selecciona condición de pago —</option>
            <option value="0" ${(f[field] === "0" || f[field] === 0) ? 'selected' : ''}>Contado (0 días)</option>
            <option value="3" ${(f[field] === "3" || f[field] === 3) ? 'selected' : ''}>3 días</option>
            <option value="7" ${(f[field] === "7" || f[field] === 7) ? 'selected' : ''}>Una semana (7 días)</option>
            <option value="15" ${(f[field] === "15" || f[field] === 15) ? 'selected' : ''}>15 días</option>
            <option value="30" ${(f[field] === "30" || f[field] === 30) ? 'selected' : ''}>Un mes (30 días)</option>
            <option value="45" ${(f[field] === "45" || f[field] === 45) ? 'selected' : ''}>45 días</option>
            <option value="60" ${(f[field] === "60" || f[field] === 60) ? 'selected' : ''}>Dos meses (60 días)</option>
            <option value="90" ${(f[field] === "90" || f[field] === 90) ? 'selected' : ''}>Tres meses (90 días)</option>
          </select>
        </div>
      `;
    }

    if (isFormaPago) {
      const formas = ["Transferencia bancaria","Efectivo","Cheque","Consignación","Tarjeta de crédito","PSE","50% anticipo — 50% contra entrega"];
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <input data-form="${field}" list="list-formas-pago" value="${escapeHTML(value)}" placeholder="🔍 Escribe o selecciona..." autocomplete="off" style="${inputStyle}"/>
          <datalist id="list-formas-pago">
            ${formas.map(fp => `<option value="${fp}"></option>`).join("")}
          </datalist>
          <div style="font-size:10px;color:${C.muted};margin-top:3px;">💡 Se precarga en la cotización al seleccionar este cliente.</div>
        </div>
      `;
    }

    if (isEsVendedor) {
      const activo = f.es_vendedor === true || f.es_vendedor === "1" || f.es_vendedor === "true";
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <select data-form="${field}" style="${inputStyle}">
            <option value="" ${activo ? "" : "selected"}>No</option>
            <option value="1" ${activo ? "selected" : ""}>Sí — vende sin cambiar de cargo</option>
          </select>
          <div style="font-size:10px;color:${C.muted};margin-top:3px;">💡 Para gerentes o administrativos que también generan ventas: aparecen como asesor comercial al crear clientes y entran en la liquidación de comisiones, conservando su cargo. Si el cargo ya es "Vendedor", no hace falta.</div>
        </div>
      `;
    }

    if (isRango) {
      const tabla = getTablaComisiones();
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <select data-form="${field}" style="${inputStyle}">
            ${tabla.rangosVendedor.map(r => `<option value="${r.id}" ${(f[field]||"general")===r.id?"selected":""}>${escapeHTML(r.label)}</option>`).join("")}
          </select>
          <div style="font-size:10px;color:${C.muted};margin-top:3px;">💡 El rango determina la tabla de comisiones aplicada. Puedes configurar los rangos en Comisiones → Tabla.</div>
        </div>
      `;
    }

    if (isCargo) {
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <select data-form="${field}" style="${inputStyle}">
            <option value="">— Selecciona un cargo —</option>
            ${CARGOS_EMPLEADO.map(c => `<option value="${c}" ${(f[field]||"")===c?"selected":""}>${CARGO_LABELS[c]}</option>`).join("")}
          </select>
        </div>
      `;
    }

    if (isTipoContrato) {
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <select data-form="${field}" style="${inputStyle}">
            <option value="">— Selecciona un tipo de contrato —</option>
            ${TIPOS_CONTRATO.map(t => `<option value="${t}" ${(f[field]||"")===t?"selected":""}>${TIPO_CONTRATO_LABELS[t]}</option>`).join("")}
          </select>
        </div>
      `;
    }

    if (isNivelRiesgoArl) {
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <select data-form="${field}" style="${inputStyle}">
            <option value="">— Selecciona un nivel —</option>
            ${NIVELES_RIESGO_ARL.map(n => `<option value="${n}" ${(f[field]||"")===n?"selected":""}>${NIVEL_RIESGO_ARL_LABELS[n]}</option>`).join("")}
          </select>
        </div>
      `;
    }

    if (isPeriodicidadPago) {
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <select data-form="${field}" style="${inputStyle}">
            <option value="">— Usar periodicidad general de la empresa —</option>
            ${PERIODICIDAD_NOMINA.map(p => `<option value="${p}" ${(f[field]||"")===p?"selected":""}>${PERIODICIDAD_NOMINA_LABELS[p]}</option>`).join("")}
          </select>
        </div>
      `;
    }

    if (isGenero) {
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <select data-form="${field}" style="${inputStyle}">
            <option value="">— Selecciona —</option>
            <option value="Masculino" ${f[field]==="Masculino"?"selected":""}>Masculino</option>
            <option value="Femenino" ${f[field]==="Femenino"?"selected":""}>Femenino</option>
            <option value="Otro" ${f[field]==="Otro"?"selected":""}>Otro</option>
          </select>
        </div>
      `;
    }

    if (isAsesor) {
      const vendedores = getVendedores();
      const asesorActual = vendedores.find(v => v.nombre === f[field]);
      return `
        <div style="${colSpan}">
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">🧑‍💼 Asesor comercial asignado</label>
          <select data-form="${field}" style="${inputStyle}cursor:pointer;">
            <option value="">— Sin asesor asignado —</option>
            ${vendedores.map(v => `<option value="${escapeHTML(v.nombre)}" ${(f[field]||"")===v.nombre?"selected":""}>` +
              `${escapeHTML(v.nombre)}${v.rango ? " — " + escapeHTML(v.rango) : ""}</option>`
            ).join("")}
          </select>
          ${asesorActual ? `
            <div style="margin-top:6px;display:flex;align-items:center;gap:8px;">
              <span style="background:${C.amber}18;color:${C.amber};padding:3px 10px;border-radius:6px;font-size:10.5px;font-weight:700;">🧑‍💼 ${escapeHTML(asesorActual.nombre)}</span>
              ${asesorActual.rango ? `<span style="background:#f1f5f9;color:${C.muted};padding:2px 8px;border-radius:6px;font-size:10.5px;">${escapeHTML(asesorActual.rango)}</span>` : ""}
              ${asesorActual.email ? `<span style="font-size:10px;color:${C.muted};">${escapeHTML(asesorActual.email)}</span>` : ""}
            </div>
          ` : ""}
          ${vendedores.length === 0 ? `<div style="font-size:10px;color:${C.amber};margin-top:4px;font-weight:600;">💡 Primero crea un empleado con cargo "Vendedor" — o marca "También es vendedor" en cualquier empleado (p. ej. el gerente) — en el módulo de Empleados</div>` : ""}
        </div>
      `;
    }

    if (isFecha) {
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <input data-form="${field}" type="date" value="${escapeHTML(value)}" style="${inputStyle}"/>
        </div>
      `;
    }

    if (isBanco) {
      const bancos = ["Bancolombia","Banco de Bogotá","Davivienda","BBVA Colombia","Banco de Occidente","Banco Popular","Banco Caja Social","Scotiabank Colpatria","Banco Agrario","Banco AV Villas","Citibank Colombia","Banco GNB Sudameris","Itaú","Banco Falabella","Banco Pichincha","Bancoomeva","Nequi","Daviplata","Lulo Bank","Movii"];
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <input data-form="${field}" list="list-bancos" value="${escapeHTML(value)}" placeholder="🔍 Escribe o selecciona un banco..." autocomplete="off" style="${inputStyle}"/>
          <datalist id="list-bancos">
            ${bancos.map(b => `<option value="${b}"></option>`).join("")}
          </datalist>
        </div>
      `;
    }

    if (isMargen) {
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]}</label>
          <input data-form="${field}" type="number" inputmode="decimal" step="0.01" min="0" max="99" value="${escapeHTML(value)}" placeholder="Ej: 30" style="${inputStyle}text-align:right;"/>
          <div style="font-size:10px;color:${C.muted};margin-top:3px;">El precio de venta se calcula automáticamente: Costo ÷ (1 − margen).</div>
        </div>
      `;
    }

    // El campo Costo de un KIT no se teclea: lo deriva su receta. Dejarlo
    // editable invitaría a escribir un número que el guardado sobrescribe.
    if (field === "costo" && key === "productos" && f.es_kit && (f._componentesKit || []).length) {
      const derivado = costoKitCatalogo(f) || 0;
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]} (del kit)</label>
          <div style="${inputStyle}text-align:right;background:#faf5ff;font-weight:700;color:#6b21a8;" title="Suma de los costos de los componentes. Se actualiza solo cuando cambia el costo de una de las partes.">${formatMiles(derivado)}</div>
          <input type="hidden" data-form="costo" value="${derivado}"/>
        </div>
      `;
    }

    if (isPrecioVentaCalc) {
      const costoNum = costoBaseProducto(f);
      const margenNum = parseNumber(f.margen) || 0;
      const complemento = 1 - (margenNum / 100);
      const precioCalc = complemento > 0 ? Math.round(costoNum / complemento) : 0;
      f.precio_venta = precioCalc;
      return `
        <div>
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field]} (calculado)</label>
          <div id="precio-venta-calculado" style="${inputStyle}text-align:right;background:#f8fafc;font-weight:700;color:${C.text};">${formatMiles(precioCalc)}</div>
          <input type="hidden" data-form="precio_venta" value="${precioCalc}"/>
        </div>
      `;
    }

    return `
      <div style="${colSpan}">
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${labels[field] || field}</label>
        <input 
          data-form="${field}"
          type="${isNumber ? 'number' : 'text'}"
          inputmode="${isNumber ? 'decimal' : 'text'}"
          value="${escapeHTML(value)}"
          placeholder="${field === 'nit' ? 'Ej: 123456789' : (field === 'contacto' ? 'Nombre de la persona' : (field === 'contacto_cargo' ? 'Ej: Gerente de Compras' : ''))}"
          style="${inputStyle}${isNumber ? 'text-align:right;' : ''}"
        />
      </div>
    `;
  }).join("");

  // El código interno lo asigna el sistema al crear el producto y no se edita:
  // es la referencia con la que Mathiz nombra su catálogo, y renumerar a mano
  // rompería la secuencia. Se muestra para poder leerlo y dictarlo.
  const codigoHTML = (key === "productos" && f.codigo_interno) ? `
    <div style="margin-bottom:12px;display:flex;align-items:center;gap:9px;background:#f8fafc;border:1px solid ${C.border};border-radius:7px;padding:8px 11px;">
      <span style="font-size:10.5px;color:${C.muted};font-weight:600;">CÓDIGO INTERNO</span>
      <strong style="font-family:ui-monospace,monospace;font-size:15px;color:${C.mathiz};letter-spacing:1px;">${escapeHTML(f.codigo_interno)}</strong>
      <span style="font-size:10px;color:${C.muted};margin-left:auto;">Lo asigna AURA y no cambia</span>
    </div>` : "";

  const imagenHTML = key === "productos" ? `
    <div style="margin-top:14px;padding-top:14px;border-top:1px solid ${C.border};">
      <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:6px;">📷 Imagen del producto</label>
      ${zonaImagenHTML({ destino:"maestro", inputId:"producto-imagen-input", imagen:srcImagenProducto(f) })}
      <div style="display:flex;justify-content:space-between;align-items:center;gap:10px;margin-top:5px;flex-wrap:wrap;">
        <div style="font-size:10px;color:${C.muted};">Esta imagen se mostrará en la impresión de Cotizaciones.</div>
        ${(f.imagen || f.imagen_path) ? `<button data-action="remove-producto-imagen" style="background:transparent;border:none;color:${C.red};cursor:pointer;font-size:10.5px;text-decoration:underline;padding:0;">🗑 Quitar imagen</button>` : ""}
      </div>
    </div>
  ` : "";

  // ─── Producto KIT: la receta ───────────────────────────────────────────────
  // Un kit se vende armado y NO es inventariable: al cliente le llega "Set
  // escolar" y de la bodega salen sus cuadernos y sus lápices. Por eso aquí se
  // configura QUÉ lleva y CUÁNTOS de cada uno, y el costo deja de digitarse:
  // se deriva de las partes, así que no envejece cuando sube el cuaderno.
  const compsKit = f._componentesKit || [];
  const armablesHoy = f.es_kit && compsKit.length
    ? detalleArmablesKit(f, a => getStockDisponible(a)) : [];
  const puedeArmar = f.es_kit && compsKit.length ? armablesDeKit(f, a => getStockDisponible(a)) : null;
  const costoDerivado = f.es_kit ? costoKitCatalogo(f) : null;
  const kitHTML = key !== "productos" ? "" : `
    <div style="margin-top:14px;padding-top:14px;border-top:1px solid ${C.border};">
      <label style="display:flex;align-items:center;gap:7px;font-size:12px;color:${C.text};font-weight:700;cursor:pointer;"
        title="Un kit se vende armado: al cliente le llega un solo artículo y de la bodega salen sus componentes. No es inventariable.">
        <input data-form="es_kit" type="checkbox" data-checkbox="1" ${f.es_kit ? "checked" : ""}/>
        🧩 Este producto es un KIT (se vende armado)
      </label>
      ${!f.es_kit ? `
        <div style="font-size:10px;color:${C.muted};margin-top:5px;line-height:1.5;">
          Márcalo si el producto se arma con otros del catálogo — por ejemplo un
          <b>Set escolar</b> de 2 cuadernos y 3 lápices. El kit no entra al inventario:
          inventariables son sus componentes.
        </div>` : `
        <div style="background:#faf5ff;border:1px solid #d8b4fe;border-radius:8px;padding:10px 12px;margin-top:9px;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
            <div style="font-size:11px;font-weight:700;color:#6b21a8;">COMPONENTES — cuántos lleva UNA unidad</div>
            <button data-action="add-comp-kit" style="${btnStyle("#7c3aed", null, true)}">+ Agregar componente</button>
          </div>
          ${compsKit.length === 0 ? `
            <div style="padding:10px;text-align:center;background:white;border:1px dashed #d8b4fe;border-radius:6px;color:${C.muted};font-size:11px;">
              Sin componentes todavía. Un kit sin componentes no se puede entregar:
              su stock se calcula con el de sus partes.
            </div>` : `
            <datalist id="list-comp-kit">${(state.data.productos || [])
              .filter(p => p.id !== f.id && !p.es_kit)
              .map(p => `<option value="${escapeHTML(p.nombre)}"></option>`).join("")}</datalist>
            <table style="width:100%;border-collapse:collapse;font-size:11.5px;background:white;border-radius:6px;overflow:hidden;">
              <thead><tr style="background:#f3e8ff;">
                <th style="padding:5px 8px;text-align:left;font-size:10px;font-weight:700;color:#6b21a8;">Artículo</th>
                <th style="padding:5px 8px;text-align:right;font-size:10px;font-weight:700;color:#6b21a8;width:90px;">Cantidad</th>
                <th style="padding:5px 8px;text-align:right;font-size:10px;font-weight:700;color:#6b21a8;width:110px;">Costo c/u</th>
                <th style="padding:5px 8px;text-align:right;font-size:10px;font-weight:700;color:#6b21a8;width:110px;">Subtotal</th>
                <th style="width:30px;"></th>
              </tr></thead>
              <tbody>
                ${compsKit.map((c, i) => {
                  const prodC = productoPorNombre(c.articulo);
                  const cant = parseNumber(c.cantidad) || 0;
                  const costoC = prodC ? (parseNumber(prodC.costo) || 0) : 0;
                  const disp = prodC ? getStockDisponible(prodC.nombre) : 0;
                  return `
                  <tr style="border-top:1px solid #f3e8ff;">
                    <td style="padding:3px;">
                      <input data-comp-kit="${i}" data-comp-field="articulo" list="list-comp-kit" autocomplete="off"
                        value="${escapeHTML(c.articulo || "")}" placeholder="🔍 Producto del catálogo"
                        style="${inputStyle}font-size:11.5px;padding:5px 7px;"/>
                      ${c.articulo && !prodC
                        ? `<div style="font-size:9.5px;color:#b45309;margin-top:2px;font-weight:700;">No está en el catálogo — no se puede armar con él</div>`
                        : (prodC ? `<div style="font-size:9.5px;color:${C.muted};margin-top:2px;">${disp} disponibles en bodega</div>` : "")}
                    </td>
                    <td style="padding:3px;"><input data-comp-kit="${i}" data-comp-field="cantidad" type="number" inputmode="decimal" min="0" step="1"
                      value="${c.cantidad != null ? escapeHTML(String(c.cantidad)) : ""}" placeholder="0"
                      style="${inputStyle}font-size:11.5px;padding:5px 7px;text-align:right;"/></td>
                    <td style="padding:3px;text-align:right;color:${C.muted};">${prodC ? fmtCOP(costoC) : "—"}</td>
                    <td style="padding:3px;text-align:right;font-weight:700;color:${C.text};">${prodC ? fmtCOP(cant * costoC) : "—"}</td>
                    <td style="padding:3px;text-align:center;">
                      <button data-action="remove-comp-kit" data-idx="${i}" style="background:transparent;border:none;color:${C.red};cursor:pointer;font-size:15px;">🗑</button>
                    </td>
                  </tr>`;
                }).join("")}
              </tbody>
            </table>
            <div style="display:flex;gap:14px;flex-wrap:wrap;align-items:center;margin-top:9px;padding-top:8px;border-top:1px solid #d8b4fe;">
              <div style="font-size:11.5px;color:${C.text};">
                Costo de armar uno: <b style="font-size:13px;">${fmtCOP(costoDerivado || 0)}</b>
                <span style="font-size:10px;color:${C.muted};"> — se deriva de las partes, no se digita</span>
              </div>
              <div style="margin-left:auto;font-size:11.5px;color:${C.text};">
                Se pueden armar <b style="font-size:14px;color:${puedeArmar > 0 ? "#059669" : C.red};">${puedeArmar === Infinity ? 0 : (puedeArmar || 0)}</b>
                con el inventario de hoy
              </div>
            </div>
            ${armablesHoy.length ? `
              <div style="font-size:10px;color:${C.muted};margin-top:5px;line-height:1.6;">
                ${armablesHoy.map(x => `· ${escapeHTML(x.articulo)}: ${x.disponible} disponibles ÷ ${x.porUnidad} por unidad → alcanza para <b>${x.alcanzaPara}</b>`).join("<br>")}
              </div>` : ""}
          `}
          <div style="font-size:10px;color:#6b21a8;margin-top:8px;line-height:1.5;">
            🧾 El kit se cotiza, se remisiona y se factura como UN artículo, con su composición impresa debajo.
            Al remisionarlo salen de bodega sus componentes, no él.
          </div>
        </div>`}
    </div>`;

  const datosTributariosHTML = (key === "clientes" || key === "proveedores") ? `
    <div style="margin-top:14px;padding-top:14px;border-top:1px solid ${C.border};">
      <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:6px;">🧾 Datos tributarios (Colombia / DIAN)</label>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:10px;">
        <div>
          <label style="font-size:10px;color:${C.muted};display:block;margin-bottom:4px;">Tipo de persona</label>
          <select data-form="tipo_persona" style="${inputStyle}">
            <option value="Jurídica" ${f.tipo_persona==="Jurídica"?"selected":""}>Jurídica</option>
            <option value="Natural" ${f.tipo_persona==="Natural"?"selected":""}>Natural</option>
          </select>
        </div>
        <div>
          <label style="font-size:10px;color:${C.muted};display:block;margin-bottom:4px;">Tipo de documento</label>
          <select data-form="tipo_documento" style="${inputStyle}">
            <option value="NIT" ${(!f.tipo_documento||f.tipo_documento==="NIT")?"selected":""}>NIT</option>
            <option value="CC" ${f.tipo_documento==="CC"?"selected":""}>Cédula de ciudadanía</option>
            <option value="CE" ${f.tipo_documento==="CE"?"selected":""}>Cédula de extranjería</option>
            <option value="Pasaporte" ${f.tipo_documento==="Pasaporte"?"selected":""}>Pasaporte</option>
          </select>
        </div>
        <div>
          <label style="font-size:10px;color:${C.muted};display:block;margin-bottom:4px;">Dígito de verificación (DV)</label>
          <input data-form="dv" value="${escapeHTML(f.dv||"")}" maxlength="1" placeholder="0-9" style="${inputStyle}text-align:right;"/>
        </div>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:10px;">
        <div>
          <label style="font-size:10px;color:${C.muted};display:block;margin-bottom:4px;">Régimen fiscal</label>
          <select data-form="regimen_fiscal" style="${inputStyle}">
            ${REGIMENES_FISCALES.map(r => `<option value="${r.value}" ${(f.regimen_fiscal||"ordinario")===r.value?"selected":""}>${r.label}</option>`).join("")}
          </select>
        </div>
        <div>
          <label style="font-size:10px;color:${C.muted};display:block;margin-bottom:4px;">Ciudad / Municipio (DIAN)</label>
          <input data-form="ciudad_dian" value="${escapeHTML(f.ciudad_dian||"")}" placeholder="Ej: Bogotá D.C." style="${inputStyle}"/>
        </div>
        <div style="display:flex;align-items:flex-end;padding-bottom:8px;">
          <label style="display:flex;align-items:center;gap:6px;font-size:11.5px;color:${C.text};font-weight:600;cursor:pointer;">
            <input data-form="responsable_iva" type="checkbox" data-checkbox="1" ${f.responsable_iva?"checked":""}/> ✅ Responsable de IVA
          </label>
        </div>
      </div>
      <div style="font-size:10px;color:${C.muted};margin-top:-4px;margin-bottom:10px;">
        💡 Si el régimen es <strong>RST (Régimen Simple)</strong>, el sistema NO aplicará ReteFuente ni el componente de ReteICA automáticamente en la causación (exoneración legal — Art. 911 E.T.). Si el check de IVA está sin marcar, la factura no causará IVA ni ReteIVA.
      </div>
      ${key === "clientes" ? `
      <div style="margin-bottom:10px;">
        <label style="font-size:10px;color:${C.muted};display:block;margin-bottom:4px;">📧 Correo de facturación electrónica (buzón DIAN)</label>
        <input data-form="email_fe" type="email" value="${escapeHTML(f.email_fe||"")}" placeholder="Ej: facturacionelectronica@empresa.com" style="${inputStyle}"/>
        <div style="font-size:10px;color:${C.muted};margin-top:4px;">
          A este correo se envía la factura electrónica. Es distinto del <strong>Email</strong> de arriba, que es el del contacto comercial
          (el que sale en la cotización): si se factura al contacto, la factura no le llega a quien la radica.
          ${f.email_fe ? "" : `Si se deja vacío se usará el de contacto${f.email ? " (" + escapeHTML(f.email) + ")" : ""}.`}
        </div>
        <div id="aviso-email-fe">${avisoCorreoFEHTML(f.email_fe)}</div>
      </div>` : ""}
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:10px;margin-bottom:10px;">
        <div>
          <label style="font-size:10px;color:${C.muted};display:block;margin-bottom:4px;">Cód. actividad económica (CIIU)</label>
          <input data-form="actividad_economica" value="${escapeHTML(f.actividad_economica||"")}" placeholder="Ej: 4690" style="${inputStyle}"/>
        </div>
        <div>
          <label style="font-size:10px;color:${C.muted};display:block;margin-bottom:4px;">% Retención en la fuente</label>
          <input data-form="retefuente" type="number" inputmode="decimal" step="0.01" min="0" max="100" value="${escapeHTML(f.retefuente!=null?String(f.retefuente):"")}" placeholder="0" style="${inputStyle}text-align:right;"/>
        </div>
        <div>
          <label style="font-size:10px;color:${C.muted};display:block;margin-bottom:4px;">% ReteICA</label>
          <input data-form="reteica" type="number" inputmode="decimal" step="0.001" min="0" max="100" value="${escapeHTML(f.reteica!=null?String(f.reteica):"")}" placeholder="0" style="${inputStyle}text-align:right;"/>
        </div>
        <div>
          <label style="font-size:10px;color:${C.muted};display:block;margin-bottom:4px;">% ReteIVA</label>
          <input data-form="reteiva" type="number" inputmode="decimal" step="0.01" min="0" max="100" value="${escapeHTML(f.reteiva!=null?String(f.reteiva):"")}" placeholder="0" style="${inputStyle}text-align:right;"/>
        </div>
      </div>
      <div style="display:flex;gap:10px;flex-wrap:wrap;">
        <label style="display:flex;align-items:center;gap:6px;font-size:11.5px;color:${C.text};cursor:pointer;">
          <input data-form="gran_contribuyente" type="checkbox" data-checkbox="1" ${f.gran_contribuyente?"checked":""}/> Gran contribuyente
        </label>
        <label style="display:flex;align-items:center;gap:6px;font-size:11.5px;color:${C.text};cursor:pointer;">
          <input data-form="autorretenedor" type="checkbox" data-checkbox="1" ${f.autorretenedor?"checked":""}/> Autorretenedor
        </label>
        <label style="display:flex;align-items:center;gap:6px;font-size:11.5px;color:${C.text};cursor:pointer;">
          <input data-form="agente_retencion" type="checkbox" data-checkbox="1" ${f.agente_retencion?"checked":""}/> Agente de retención
        </label>
        ${key === "proveedores" ? `
        <label style="display:flex;align-items:center;gap:6px;font-size:11.5px;color:${C.text};cursor:pointer;"
          title="Persona natural que firma bajo juramento que no tomará costos ni deducciones (Art. 383 E.T.). Solo así esa declaración se imprime en su cuenta de cobro.">
          <input data-form="declara_383" type="checkbox" data-checkbox="1" ${f.declara_383?"checked":""}/> Firma declaración Art. 383 E.T.
        </label>` : ""}
      </div>
      <div style="font-size:10px;color:${C.muted};margin-top:6px;">💡 Estos datos se usan para calcular retenciones automáticas y para los reportes de Exógena/Medios Magnéticos.</div>
    </div>
  ` : "";

  const descuentosFinancierosHTML = key === "proveedores" ? `
    <div style="margin-top:14px;padding-top:14px;border-top:1px solid ${C.border};">
      <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:6px;">💳 Descuentos financieros ofrecidos por el proveedor</label>
      <div style="font-size:10px;color:${C.muted};margin-bottom:10px;">Agrega una condición por cada descuento pactado. El % se aplica sobre el subtotal sin impuestos.</div>
      ${(() => {
        const conds = Array.isArray(f.descuentos_financieros) ? f.descuentos_financieros : [];
        const filas = conds.map((d,i) => `
          <tr style="border-top:1px solid ${C.border};">
            <td style="padding:6px 8px;">
              <select data-desc-idx="${i}" data-desc-field="medio" style="${inputStyle}cursor:pointer;font-size:11.5px;padding:5px 8px;">
                ${MEDIOS_DESC_FIN.map(m => `<option value="${m.value}" ${(d.medio||"transferencia")===m.value?"selected":""}>${m.label}</option>`).join("")}
              </select>
            </td>
            <td style="padding:6px 8px;width:110px;">
              <div style="display:flex;align-items:center;gap:4px;">
                <input data-desc-idx="${i}" data-desc-field="pct" type="number" inputmode="decimal" step="0.01" min="0" max="100"
                  value="${escapeHTML(String(d.pct||""))}" placeholder="0" style="${inputStyle}text-align:right;font-size:11.5px;padding:5px 8px;"/>
                <span style="font-size:11.5px;color:${C.muted};">%</span>
              </div>
            </td>
            <td style="padding:6px 8px;width:160px;">
              <div style="display:flex;align-items:center;gap:4px;">
                <input data-desc-idx="${i}" data-desc-field="dias" type="number" inputmode="numeric" min="0" step="1"
                  value="${escapeHTML(String(d.dias||0))}" placeholder="0" style="${inputStyle}text-align:right;font-size:11.5px;padding:5px 8px;"/>
                <span style="font-size:10.5px;color:${C.muted};white-space:nowrap;">${(d.dias||0)==0?"(contado)":"días"}</span>
              </div>
            </td>
            <td style="padding:6px 8px;text-align:center;">
              <button data-action="desc-fin-remove" data-idx="${i}" style="${btnStyle(null,"ghost",true)}color:#ef4444;" title="Eliminar">🗑</button>
            </td>
          </tr>
        `).join("");
        return `
          <table style="width:100%;border-collapse:collapse;font-size:11.5px;border:1px solid ${C.border};border-radius:6px;overflow:hidden;">
            <thead><tr style="background:#f1f5f9;">
              <th style="padding:7px 8px;text-align:left;font-size:10.5px;font-weight:700;color:${C.muted};">MÉTODO DE PAGO</th>
              <th style="padding:7px 8px;text-align:center;font-size:10.5px;font-weight:700;color:${C.muted};">DESCUENTO %</th>
              <th style="padding:7px 8px;text-align:center;font-size:10.5px;font-weight:700;color:${C.muted};">A CUÁNTOS DÍAS</th>
              <th style="padding:7px 8px;width:40px;"></th>
            </tr></thead>
            <tbody>${filas || `<tr><td colspan="4" style="padding:9px;text-align:center;color:${C.muted};font-size:10.5px;">Sin condiciones de descuento registradas</td></tr>`}</tbody>
          </table>
          <button data-action="desc-fin-add" style="${btnStyle(C.accent,null,true)}margin-top:8px;font-size:11.5px;">+ Agregar condición de descuento</button>
        `;
      })()}
    </div>
  ` : "";

  const contactosHTML = key === "clientes" ? `
    <div style="margin-top:14px;padding-top:14px;border-top:1px solid ${C.border};">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;">👤 Personas de contacto adicionales</label>
        <button data-action="add-contacto-cliente" style="${btnStyle(C.accent,null,true)}">+ Agregar contacto</button>
      </div>
      ${(f._contactos||[]).length === 0 ? `
        <div style="font-size:10.5px;color:${C.muted};">Sin contactos adicionales. Estos podrán seleccionarse al crear una Cotización.</div>
      ` : (f._contactos||[]).map((c,i) => `
        <div style="display:flex;gap:8px;align-items:center;margin-bottom:6px;flex-wrap:wrap;">
          <input data-contacto="${i}" data-contacto-field="nombre" value="${escapeHTML(c.nombre||"")}" placeholder="Nombre" style="${inputStyle}flex:2;min-width:120px;"/>
          <input data-contacto="${i}" data-contacto-field="cargo" value="${escapeHTML(c.cargo||"")}" placeholder="Cargo" style="${inputStyle}flex:1;min-width:100px;"/>
          <input data-contacto="${i}" data-contacto-field="telefono" value="${escapeHTML(c.telefono||"")}" placeholder="Teléfono" style="${inputStyle}flex:1;min-width:100px;"/>
          <input data-contacto="${i}" data-contacto-field="email" value="${escapeHTML(c.email||"")}" placeholder="Email" style="${inputStyle}flex:2;min-width:140px;"/>
          <button data-action="remove-contacto-cliente" data-idx="${i}" style="background:transparent;border:none;color:${C.red};cursor:pointer;font-size:16px;flex-shrink:0;">🗑</button>
        </div>
      `).join("")}
      ${(() => {
        // Cuál de todos los contactos sale impreso en la cotización. Se guarda el
        // índice, no una copia: si mañana cambia el cargo de esa persona, la
        // siguiente cotización ya sale corregida.
        const lista = contactosDe(f);
        const marca = f.contacto_imprimible;
        const sinDefinir = marca == null;
        return `
        <div id="caja-contacto-imprimible" style="margin-top:12px;padding:10px 12px;border-radius:8px;background:${sinDefinir ? "#fffbeb" : "#f8fafc"};border:1px solid ${sinDefinir ? "#fcd34d" : C.border};">
          <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:5px;">
            🖨️ Contacto que se imprime en la cotización
          </label>
          <select data-form="contacto_imprimible" style="${inputStyle}cursor:pointer;">
            <option value="" ${sinDefinir ? "selected" : ""}>— Sin definir —</option>
            ${lista.map(c => `<option value="${c.idx}" ${String(marca) === String(c.idx) ? "selected" : ""}>${escapeHTML(etiquetaContacto(c))}</option>`).join("")}
            <option value="${SIN_CONTACTO}" ${String(marca) === String(SIN_CONTACTO) ? "selected" : ""}>Este cliente no tiene contacto</option>
          </select>
          <div style="font-size:10px;color:${sinDefinir ? "#92400e" : C.muted};margin-top:5px;line-height:1.5;">
            ${lista.length === 0
              ? "Escribe primero un contacto arriba (o agrega uno adicional) para poder elegirlo."
              : "Es el nombre y el cargo que aparecen en el formato impreso de la cotización."}
          </div>
        </div>`;
      })()}
    </div>
  ` : "";

  const titleMap = { clientes:"Cliente", proveedores:"Proveedor", productos:"Producto", empleados:"Empleado" };
  const title = (f.id ? "Editar " : "Nuevo ") + titleMap[key];

  state.modal = `
    <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:${key==='productos'?'920px':'560px'};max-width:100%;max-height:90vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.2);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;background:#f8fafc;">
          <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">${title}</h3>
          <div style="display:flex;gap:6px;align-items:center;">
            ${f.id && (state.data[key] || []).some(x => x.id === f.id) ? botonBitacora(key, f.id, f.nombre || f.razon_social || "", { referencia: f.nombre || "" }) : ""}
            <button data-action="close-modal" style="background:transparent;border:none;font-size:16px;color:${C.muted};cursor:pointer;">✕</button>
          </div>
        </div>
        <div style="padding:11px;">
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;">
            ${codigoHTML}
            ${inputs}
          </div>
          ${imagenHTML}
          ${datosTributariosHTML}
          ${descuentosFinancierosHTML}
          ${contactosHTML}
          ${kitHTML}
          ${key === "productos" ? fichaProductoHTML(f) : ""}
          <div style="margin-top:18px;display:flex;gap:10px;justify-content:flex-end;padding-top:14px;border-top:1px solid ${C.border};">
            <button data-action="close-modal" style="${btnStyle(null,"secondary")}">Cancelar</button>
            <button data-action="save-maestro" style="${btnStyle(C.amber)}">💾 Guardar</button>
          </div>
        </div>
      </div>
    </div>
  `;
  
  render();

}

import { registerActions } from "../ui/actions.js";

registerActions({
  "add-comp-kit": () => {
    if (!state.editingMaestro) return;
    if (!state.editingMaestro._componentesKit) state.editingMaestro._componentesKit = [];
    state.editingMaestro._componentesKit.push({ articulo: "", cantidad: 1 });
    renderMaestroFormModal();
  },
  "remove-comp-kit": (d) => {
    if (!state.editingMaestro || !state.editingMaestro._componentesKit) return;
    state.editingMaestro._componentesKit.splice(parseInt(d.idx), 1);
    renderMaestroFormModal();
  },
  "update-product-cost": (d, el, e) => {{
      const productId = d.productId;
      const prod = (state.data.productos||[]).find(p => p.id === productId);
      if (!prod) return;
      state._costoUpdateProductId = productId;
      state.modal = `
        <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.55);display:flex;align-items:center;justify-content:center;z-index:1100;padding:11px;">
          <div data-action="prevent-close" style="background:white;border-radius:6px;width:380px;max-width:100%;box-shadow:0 20px 60px rgba(0,0,0,.3);">
            <div style="padding:18px 20px;border-bottom:1px solid ${C.border};">
              <h3 style="margin:0;font-size:12px;color:${C.text};font-weight:700;">⚠️ Actualizar costo</h3>
              <div style="font-size:11.5px;color:${C.muted};margin-top:4px;">${escapeHTML(prod.nombre)}</div>
            </div>
            <div style="padding:11px;">
              <p style="margin:0 0 12px;font-size:11.5px;color:${C.muted};">
                El costo de este producto ${prod._costo_fecha ? "no se ha actualizado hace más de 15 días" : "no tiene fecha de actualización registrada"}.
                Costo actual: <strong style="color:${C.text};">${fmtCOP(parseNumber(prod.costo)||0)}</strong>
              </p>
              <label style="font-size:10.5px;color:${C.muted};font-weight:600;">Nuevo costo</label>
              <input id="nuevo-costo-input" type="number" inputmode="decimal" value="${parseNumber(prod.costo)||0}" style="${inputStyle}text-align:right;margin-top:4px;"/>
              <div style="margin-top:18px;display:flex;gap:10px;justify-content:flex-end;">
                <button data-action="close-modal-update-cost" style="${btnStyle(null,"secondary")}">Mantener actual</button>
                <button data-action="confirm-update-product-cost" style="${btnStyle(C.amber)}">💾 Guardar costo</button>
              </div>
            </div>
          </div>
        </div>
      `;
      render();
      return;
    }},
  "close-modal-update-cost": (d, el, e) => {{
      // Marcar fecha actual aunque no cambie el valor, para no preguntar de nuevo hoy
      const pid = state._costoUpdateProductId;
      const list = state.data.productos || [];
      saveData("productos", list.map(p => p.id === pid ? { ...p, _costo_fecha: today() } : p));
      state._costoUpdateProductId = null;
      state.modal = null;
      renderDocFormModal();
      return;
    }},
  "confirm-update-product-cost": (d, el, e) => {{
      const pid = state._costoUpdateProductId;
      const input = document.getElementById("nuevo-costo-input");
      const nuevoCosto = parseNumber(input ? input.value : 0);
      const list = state.data.productos || [];
      saveData("productos", list.map(p => p.id === pid ? { ...p, costo: nuevoCosto, _costo_fecha: today() } : p));
      state._costoUpdateProductId = null;
      state.modal = null;
      renderDocFormModal();
      return;
    }},
  "ir-maestro": (d, el, e) => {{
      // Navega a maestros y resalta el registro buscado
      state.globalSearch = "";
      navigateTo("maestros");
      // Opcionalmente filtrar por nombre del registro
      return;
    }},
  "new-maestro": (d, el, e) => {showMaestroForm(d.key, null);
      return;},
  "edit-maestro": (d, el, e) => {{
      const item = state.data[d.key].find(x => x.id === d.id);
      showMaestroForm(d.key, item);
      return;
    }},
  "delete-maestro": (d, el, e) => {{
      const item = state.data[d.key].find(x => x.id === d.id);
      if (!item) return;
      
      // Verificar si el maestro se está usando en documentos
      let enUso = false;
      let usadoEn = [];
      
      if (d.key === "clientes") {
        if (state.data.cotizaciones.some(doc => doc.cliente_id === d.id)) usadoEn.push("Cotizaciones");
        if (state.data.pedidos.some(doc => doc.cliente_id === d.id)) usadoEn.push("Órdenes de Producción");
        if (state.data.remisiones.some(doc => doc.cliente_id === d.id)) usadoEn.push("Remisiones");
        enUso = usadoEn.length > 0;
      } else if (d.key === "proveedores") {
        if (state.data.ocp.some(doc => doc.proveedor_id === d.id)) usadoEn.push("Órdenes de Compra");
        enUso = usadoEn.length > 0;
      } else if (d.key === "productos") {
        // Los productos no se validan, se elimina libremente
      }
      
      const advertencia = enUso 
        ? `<div style="background:${C.red}15;border-left:3px solid ${C.red};padding:10px;border-radius:4px;margin-bottom:10px;">
             <div style="color:${C.red};font-weight:700;margin-bottom:4px;">⚠️ ADVERTENCIA: Este registro está en uso</div>
             <div style="font-size:11.5px;color:${C.muted};">Se encontró en: ${usadoEn.join(", ")}</div>
             <div style="font-size:10.5px;color:${C.red};margin-top:4px;">Si lo eliminas, los documentos quedarán sin referencia.</div>
           </div>`
        : "";
      
      showConfirmDelete(
        "⚠️ ELIMINAR PERMANENTEMENTE",
        `<div style="color:${C.red};font-weight:700;margin-bottom:6px;">⚠️ Esta acción es irreversible</div>
         ${advertencia}
         <div style="margin:10px 0;padding:10px;background:#f3f4f6;border-radius:4px;">
           <div style="font-size:16px;font-weight:700;color:${C.text};">${escapeHTML(item.nombre)}</div>
           <div style="font-size:11.5px;color:${C.muted};margin-top:4px;">Se eliminará permanentemente.</div>
         </div>`,
        () => {
          const eliminado = deleteData(d.key, d.id);
          if (eliminado) {
            state.modal = null;
            const tipoNombre = d.key === "clientes" ? "Cliente" : d.key === "proveedores" ? "Proveedor" : "Producto";
            alert(`✅ ${tipoNombre} "${item.nombre}" eliminado permanentemente`);
            render();
          } else {
            alert("❌ Error al eliminar el registro");
          }
        }
      );
      return;
    }},
  "maestros-tab": (d, el, e) => {state.maestrosTab = d.tab;
      render();
      return;},
  "save-maestro": async (d, el, e) => {{
      
      const f = state.editingMaestro;
      const key = state.editingMaestroKey;
      
      
      // Validar nombre
      if (!f.nombre || !f.nombre.trim()) {
        alert("❌ El nombre es requerido");
        console.warn("⚠️ Nombre vacío");
        return;
      }
      
      // Validar días_pago para clientes y proveedores. Ojo: 0 (Contado) es un
      // valor VÁLIDO — no confundirlo con "sin diligenciar" (por eso no se usa
      // !f.dias_pago, que trataría el 0 como vacío).
      if ((key === "clientes" || key === "proveedores") && (f.dias_pago == null || f.dias_pago === "")) {
        alert("⚠️ Los días de pago son obligatorios para " + (key === "clientes" ? "clientes" : "proveedores"));
        console.warn("⚠️ días_pago no seleccionado");
        return;
      }
      
      
      // Obtener lista actual
      const list = state.data[key] || [];
      
      // Crear objeto final. El nombre va sin espacios sobrantes: en productos es
      // la llave con la que los documentos encuentran su ficha de inventario, y
      // un "Set de memos " con espacio final pasa por un artículo distinto.
      const final = {
        ...f,
        nombre: typeof f.nombre === "string" ? f.nombre.trim() : f.nombre,
        id: f.id || genId()
      };
      
      // Normalizar números si es producto
      if (key === "productos") {
        // El selector entrega "tipo:tarifa" en un solo campo; se guarda separado
        // porque "gravado" no significa nada sin su porcentaje y el porcentaje
        // no distingue un exento de un excluido (los dos van en cero).
        if (final.iva_regimen != null && final.iva_regimen !== "") {
          Object.assign(final, leerValorOpcion(final.iva_regimen));
        }
        delete final.iva_regimen;
        if (!final.iva_tipo) final.iva_tipo = IVA_GRAVADO;
        if (final.precio_venta != null) final.precio_venta = parseNumber(final.precio_venta);
        if (final.costo != null) final.costo = parseNumber(final.costo);
        if (final.margen != null) final.margen = parseNumber(final.margen);
        // El kit se limpia y se valida: filas vacías fuera, cantidades como
        // número, y su COSTO se deriva de las partes (un costo digitado en un
        // kit envejece en cuanto sube uno de sus componentes).
        final.es_kit = !!final.es_kit;
        if (final.es_kit) {
          final._componentesKit = (final._componentesKit || [])
            .map(c => ({ articulo: (c.articulo || "").trim(), cantidad: parseNumber(c.cantidad) || 0 }))
            .filter(c => c.articulo && c.cantidad > 0);
          const derivado = costoKitCatalogo(final);
          if (derivado != null) final.costo = Math.round(derivado);
        } else {
          delete final._componentesKit;
        }
        const prevProd = list.find(x => x.id === final.id);
        const prevCosto = prevProd ? parseNumber(prevProd.costo) : null;
        if (!prevProd || prevCosto !== final.costo || !prevProd._costo_fecha) {
          final._costo_fecha = today();
        }
      }

      // Normalizar descuentos financieros si es proveedor
      if (key === "proveedores") {
        final.desc_fin_tarjeta = parseNumber(final.desc_fin_tarjeta) || 0;
        final.desc_fin_efectivo = parseNumber(final.desc_fin_efectivo) || 0;
        final.desc_fin_transferencia = parseNumber(final.desc_fin_transferencia) || 0;
      }

      // Normalizar datos tributarios si es cliente o proveedor
      if (key === "clientes" || key === "proveedores") {
        // Porcentajes, no pesos: un ReteICA de 0,414% se guardaba como 414%.
        final.retefuente = parsePct(final.retefuente) || 0;
        final.reteica = parsePct(final.reteica) || 0;
        final.reteiva = parsePct(final.reteiva) || 0;
      }

      // El selector del contacto imprimible entrega texto: "" es «sin definir»
      // (deja al cliente en el repaso) y el resto es un índice numérico.
      if (key === "clientes") {
        // Un espacio sobrante en el correo de facturación rompe el envío.
        if (typeof final.email_fe === "string") final.email_fe = final.email_fe.trim();
        final.contacto_imprimible = (final.contacto_imprimible === "" || final.contacto_imprimible == null)
          ? null
          : Number(final.contacto_imprimible);
      }
      
      
      // Código interno para los productos nuevos: lo pone el sistema, en el
      // orden en que se dan de alta. Los que ya lo tienen no se tocan.
      if (key === "productos" && !final.codigo_interno) {
        final.codigo_interno = siguienteCodigoProducto(list);
      }

      // La foto sube al bucket y la ficha se queda solo con la ruta: guardar el
      // base64 dentro del registro es lo que llenó la cuota del navegador.
      if (key === "productos") Object.assign(final, await persistirImagenProducto(final));

      // Verificar si es edición o creación
      const exists = list.find(x => x.id === final.id);
      const isEdit = exists ? true : false;
      
      
      // Guardar
      if (isEdit) {
        saveData(key, list.map(x => x.id === final.id ? final : x));
      } else {
        saveData(key, [...list, final]);
      }
      
      // Limpiar estado
      state.modal = null;
      state.editingMaestro = null;
      state.editingMaestroKey = null;
      
      
      alert("✅ " + (isEdit ? "Actualizado" : "Creado") + " correctamente");
      render();
      return;
    }},
});
